// First we need to import axios.js
import axios from "axios";
import { LOCAL_URL, URL } from "./index";
// Next we make an 'instance' of it
const api = axios.create({
  // .. where we make our configurations
  baseURL: URL,
  // baseURL: LOCAL_URL,
});

// Add request interceptor to dynamically get token from localStorage on every request
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem("token_weiots_cms");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

export default api;
